import { createFileRoute } from '@tanstack/react-router'
import AgreementContainer from 'Royalty/containers/AgreementContainer'
import { agreementQueries } from 'Royalty/utils/queries'

import { PageSkeleton } from 'Common/components/skeletons'

import { Guard } from '../../-guard'
import { prefetchWhenAuthenticated } from '../../-prefetch'

export const Route = createFileRoute('/royalty_/agreement/$id')({
    loader: ({ context, params }) =>
        prefetchWhenAuthenticated(context.queryClient, agreementQueries.detail(Number(params.id))),
    pendingComponent: () => <PageSkeleton variant="detail" />,
    component: () => (
        <Guard claims={['opus_royalty']}>
            <AgreementContainer />
        </Guard>
    ),
})
